




async function checkCartGift() {

  fetch('/cart.json').then((resp) => {
    return resp.json()
  }).then((data) => {

    let has_item = false;
    let has_gift_product = false;
    let nb_products = 0;

    for (const prod of _discount_products) {
      for (const item of data.items) {
        if (item.variant_id == prod) {
          nb_products++;
        }
        if (_discount_product == item.variant_id)
          has_gift_product = true;
      }
    }

    if (nb_products < _discount_minimum) {
      if (has_gift_product) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            quantity: 0,
            id: _discount_product.toString()
          })
        }).then((response) => {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: _discount_product,
              quantity: 0
            }
          }));
        });
      }
    } else {
      if (!has_gift_product) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: _discount_product.toString(),
            quantity: 1
          })
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _discount_product,
                quantity: 1
              }
            }));
          });
      }
    }
  });
  checkAutoGift();
}
checkCartGift();


function removeProduct(id) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      quantity: 0,
      id: id.toString()
    })
  }).then((response) => {
    document.dispatchEvent(new CustomEvent('product:updated', {
      bubbles: true,
      detail: {
        variant: id,
        quantity: 0
      }
    }));
  });
}

function addProduct(id) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: id.toString(),
      quantity: 1
    })
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      document.dispatchEvent(new CustomEvent('product:updated', {
        bubbles: true,
        detail: {
          variant: id,
          quantity: 1
        }
      }));
    });
}

async function checkAutoGift() {

  fetch('/cart.json').then((resp) => {
    return resp.json()
  }).then((data) => {


    let has_item = false;
    let has_gift_product = false;
    let nb_products = 0;
    let total_price = 0;

    for (const item of data.items) {
      if (!item.gift_card)
        total_price += item.final_line_price;
    }

    for (const prod of _freegift) {
      for (const item of data.items) {
        if (item.variant_id == prod.product) {
          console.log(item.variant_id + ' -- ' + prod.product);
          if (prod.minimum < (total_price / 100)) {
            nb_products++;
          } else {
            removeProduct(item.variant_id);
          }
        }
      }
    }


    let counter = 0;
    for (const prod of _freegift) {
      if (prod.product) {
        counter++;
      }
    }


    for (const item of data.items) {
      if (item.variant_id == 44746182820169) {
        removeProduct(44746182820169);
      }
    }




    for (const prod of _freegift) {
      if (nb_products < counter) {
        if ((total_price / 100) >= prod.minimum) {
          let has_item = false;
          for (const item of data.items) {
            if (item.variant_id == prod.product) {
              has_item = true;
            }
          }
          if (!has_item) {
            addProduct(prod.product)
          }
        }
      }
    }


  });
}

checkAutoGift();




class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.productId = '';
    this.quantity = 1;

    this.querySelectorAll(".slider__button").forEach((button) => {
      button.addEventListener('click', this.addToCart.bind(this))
    })

    const swiper = new Swiper(this.querySelector('.swiper'), {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      cssMode: true,
      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        347: {
          cssMode: false,
          spaceBetween: 30,
          slidesPerView: 'auto'
        },
        749: {
          cssMode: false,
          spaceBetween: 30,
          slidesPerView: 3
        },

        1100: {
          cssMode: false,
          slidesPerView: 4.3,
          spaceBetween: 30
        },

      },
      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },



    });
  }

  addToCart(e) {

    this.productId = e.currentTarget.parentNode.querySelector('.input-quantity').value;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: this.productId.toString(),
        quantity: 1
      })
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: this.productId,
              quantity: 1
            }
          }));
      });
  }
}

customElements.define('collection-slider', CollectionSlider);


class ProductCardV2 extends HTMLElement {
  constructor() {
    super();



    this.swiperType = new Swiper(this.querySelector('.product-card__slider'), {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      spaceBetween: 3,
      slidesPerView: "auto",
      a11y: false,
      speed: 400,
      threshold: 15,

      // If we need pagination

      navigation: {
        nextEl: this.querySelector('.swiper-card-next'),
        prevEl: this.querySelector('.swiper-card-prev'),
      },
    });
  }
}

customElements.define('product-card-v2', ProductCardV2);



